<template>
  <div>
    <div v-if="isAdmin" class="d-flex justify-end pa-2">
      <v-btn-toggle v-model="selectedView" mandatory density="compact" rounded="lg">
        <v-btn value="general" prepend-icon="mdi-view-dashboard">General</v-btn>
        <v-btn value="technician" prepend-icon="mdi-wrench">Technicien</v-btn>
      </v-btn-toggle>
    </div>
    <TechnicianDashboard v-if="showTechnician"></TechnicianDashboard>
    <GeneralDashboard v-else></GeneralDashboard>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useSessionStore } from "@/store";
import GeneralDashboard from "./GeneralDashboard.vue";
import TechnicianDashboard from "./TechnicianDashboard.vue";

const sessionStore = useSessionStore();

const isAdmin = computed(() =>
  sessionStore.loggedUser?.roles?.includes("ROLE_ADMIN") ?? false
);

const isTechnical = computed(
  () => sessionStore.loggedUser?.technical === true
);

const selectedView = ref<"general" | "technician">(
  isTechnical.value ? "technician" : "general"
);

const showTechnician = computed(() =>
  isAdmin.value
    ? selectedView.value === "technician"
    : isTechnical.value
);
</script>
